module.exports = __webpack_public_path__ + "img/21.d1395a02.jpg";